<template>
  <div>
    <b-field class="file is-primary">
      <b-upload
        v-model="file"
        class="file-label shadow rounded font-display flex items-center border-2 transition hover:shadow-xl"
        @click="$refs.fileInput.click()"
      >
        <input
          style="display: none"
          ref="fileInput"
          type="file"
          @change="selectFile"
        />
        <span class="file-cta has-text-white">
          <i class="fa fa-upload mr-4"></i>
          <span class="file-label">{{ text }}</span>
        </span>
        <span class="file-name" v-if="file">
          {{ file.name }}
        </span>
      </b-upload>
    </b-field>

    <div class="max-w-xs max-h-80" v-if="isEdit && file">
      <img :src="URL.createObjectURL(file)" :alt="altText" />
    </div>

    <form v-if="!hideButtons" @submit.prevent="upload">
      <div
        :class="
          isEdit
            ? 'flex justify-between'
            : 'w-full flex flex-wrap pt-2 justify-start'
        "
      >
        <Lynx-Button
          v-if="!thereAreNotFile || isEdit"
          class="is-light mr-2"
          @click.native="isEdit ? goBack(goBackUrl) : removeFile()"
          :text="isEdit ? 'Voltar' : 'Cancelar'"
        />
        <Lynx-Button
          class="is-success"
          type="submit"
          :disabled="thereAreNotFile && !isEdit"
          :loading="loading"
          :text="isEdit ? 'Salvar' : 'Enviar'"
        />
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: "UploadFile",
  props: {
    uploadSuccess: Boolean,
    isEdit: { type: Boolean, default: false },
    hideButtons: { type: Boolean, default: false },
    goBackUrl: String,
    fileData: Object,
    defaultFile: {
      type: [File, null],
      default: null,
    },
    loading: { type: Boolean, default: false },
    text: {
      type: String,
      default: "Clique para escolher o arquivo",
    },
    slug: String,
    altText: {
      type: String,
      default: "Image",
    },
  },
  data() {
    return {
      file: null,
      URL: URL,
    };
  },
  computed: {
    thereAreNotFile() {
      return this.file === null;
    },
  },
  created() {
    if (this.defaultFile) {
      this.file = this.defaultFile;
    }
  },
  methods: {
    selectFile(event) {
      const selectedFile = event.target.files[0];
      if (!selectedFile) return;

      if (
        this.fileData &&
        this.fileData.mimeType.includes(selectedFile.type)
      ) {
        this.file = selectedFile;
        if (this.hideButtons) this.upload();
      } else {
        this.$snack.error("Tipo de arquivo inválido.");
      }
    },
    removeFile() {
      this.file = null;
      this.$refs.fileInput.value = null;
    },
    goBack(url) {
      if (url) {
        this.$router.push({
          name: url,
        });
        return;
      }
      this.$emit("close");
    },
    upload() {
      if (this.slug && this.file) {
        this.file.slug = this.slug;
      }
      if (this.file) {
        this.$emit("upload", this.file);
      }
    },
  },
  watch: {
    uploadSuccess(newValue) {
      if (newValue) {
        this.file = null;
      }
    },
    defaultFile(value) {
      if (value) {
        this.file = this.defaultFile;
      }
    },
  },
};
</script>
